<div class="app-container container-xxl">
    <div class="container mt-5">
        <div class="row">
            <h1 class="text-white">Your Atomix Clients</h1>
        </div>
        <div class="row mb-5">
            <div class="col">
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="activeTab === 'clients'" (click)="setActiveTab('clients')">Clients</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="activeTab === 'webhooks'" (click)="setActiveTab('webhooks')">Webhooks</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tab-content">
            <div [class.show]="activeTab === 'clients'" [class.active]="activeTab === 'clients'" class="tab-pane fade">
                <div class="row mb-4" style="margin-top: 55px;">
                    <div class="col-md-6">
                        <span class="text-white" *ngIf="totalItems > 0">
                            Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }} clients
                        </span>
                    </div>
                    <div class="col-md-6 text-end">
                        <div class="input-group ms-auto" style="max-width: 450px;">
                            <div class="form-control d-flex align-items-center p-0 pe-2 position-relative" style="border-right: 0;">
                                <input 
                                    type="text" 
                                    class="border-0 flex-grow-1 form-control shadow-none" 
                                    placeholder="Search clients..." 
                                    [(ngModel)]="searchTerm"
                                    (keyup.enter)="searchClients()"
                                >
                                <span *ngIf="searchTerm && searchTerm.length > 0" 
                                   class="d-flex align-items-center justify-content-center" 
                                   style="cursor: pointer; width: 24px; height: 24px; margin-right: 4px;" 
                                   (click)="clearSearch()">
                                    <i class="bi bi-x" style="font-size: 24px; color: #666;"></i>
                                </span>
                            </div>
                            <button class="btn btn-primary" type="button" (click)="searchClients()">
                                <i class="bi bi-search"></i> Search
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6 col-md-6 col-sm-6 col-lg-3 mb-3">
                        <div class="card h-150px h-sm-200 mb-4 cursor-pointer" (click)="createClient()">
                            <div class="card-body d-flex flex-column align-items-center justify-content-center text-center">
                                <div class="row card-title">
                                    <span class="bi bi-plus-lg icon-add text-primary"></span>
                                    <h3 class="text-primary">Add Client</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6 col-md-6 col-sm-6 col-lg-3 mb-3" *ngFor="let client of clients">
                        <app-client-card [client]="client" (selected)="selectClient($event)"></app-client-card>
                    </div>
                </div>

                <div class="row" *ngIf="clients.length === 0">
                    <div class="col-12 text-center py-5">
                        <h4 class="text-white">{{ isSearching ? 'No clients match your search criteria' : 'No clients found' }}</h4>
                    </div>
                </div>

                <div class="row mt-4" *ngIf="totalItems > 0">
                    <div class="col-12 d-flex align-items-center">
                        <div class="me-auto">
                            <span class="text-dark">
                                Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }} clients
                            </span>
                        </div>
                        
                        <nav aria-label="Client pagination">
                            <ul class="pagination mb-0">
                                <li class="page-item" [class.disabled]="currentPage === 1">
                                    <a class="page-link" href="javascript:void(0)" (click)="prevPage()">Previous</a>
                                </li>
                                
                                <li class="page-item" *ngFor="let page of getPageNumbers()" [class.active]="page === currentPage">
                                    <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
                                </li>
                                
                                <li class="page-item" [class.disabled]="currentPage >= getTotalPages()">
                                    <a class="page-link" href="javascript:void(0)" (click)="nextPage()">Next</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <div [class.show]="activeTab === 'webhooks'" [class.active]="activeTab === 'webhooks'" class="tab-pane fade">
                <app-webhooks-list></app-webhooks-list>
            </div>
        </div>
    </div>
</div>
